import PosButton from '@/components/PosButton';
import UserAvatar from '@/components/User/UserAvatar';
import { UserInfo } from '@/components/User/UserInfo';
import { FullscreenOutlined, LinkOutlined, UserOutlined } from '@ant-design/icons';
import { Avatar, Flex, Space, Typography } from 'antd';
import BindUser from '../FastActions/BindUser';
import { usePreOrderStore } from '../store/usePreOrderStore';
import { useStyles } from './style';
import { useContext } from 'react';
import { BaseInfoContext } from '@/context/BaseInfoContext';

export const UserArea = ({}: {}) => {
  const { styles } = useStyles();
  const preOrder = usePreOrderStore(s => s.preOrder);
  const [, , helpers] = useContext(BaseInfoContext);
  const userFullInfo = preOrder ? preOrder.userFullInfo : undefined;

  return (
    <div className={styles.container}>
      {!userFullInfo && (
        <div className={styles.notBind}>
          <Flex gap={8} align="center">
            <Avatar size={34} icon={<UserOutlined />} />
            未绑定客户
          </Flex>

          <BindUser
            popoverPlacement="bottomRight"
            userFullInfo={preOrder.userFullInfo}
            renderButton={() => {
              return <PosButton icon={<LinkOutlined />}>绑定客户</PosButton>;
            }}
          />
        </div>
      )}
      {userFullInfo && (
        <Flex justify="space-between" align="center" className={styles.bind}>
          <UserInfo user={userFullInfo.user}>
            {({ Field, user }) => (
              <Field type="modalTriggerWrapper">
                <Flex align="center" gap={8}>
                  <Field type="avatar" avatarProps={{ size: 34 }} />
                  <Flex vertical gap={0}>
                    <Field type="name" />
                    <Space size={8}>
                      <Typography.Text type="secondary">
                        套餐卡: <Typography.Text strong>{userFullInfo.cardList?.length || 0}</Typography.Text>
                      </Typography.Text>
                      <Typography.Text type="secondary">
                        余额: <Typography.Text strong>{user.balance}</Typography.Text>
                      </Typography.Text>
                    </Space>
                  </Flex>
                </Flex>
              </Field>
            )}
          </UserInfo>
          <PosButton
            icon={<FullscreenOutlined />}
            onClick={() => {
              helpers.showUserModal({
                userId: userFullInfo.user.id,
              });
            }}
          />
        </Flex>
      )}
    </div>
  );
};
